/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetDealsTotalAmountRequest
 */
export interface GetDealsTotalAmountRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDealsTotalAmountRequest
     */
    'dealStatusList'?: Array<GetDealsTotalAmountRequestDealStatusListEnum>;
    /**
     * 
     * @type {string}
     * @memberof GetDealsTotalAmountRequest
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDealsTotalAmountRequest
     */
    'userAccountGroupId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDealsTotalAmountRequest
     */
    'dealKeyword'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDealsTotalAmountRequest
     */
    'dealIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetDealsTotalAmountRequest
     */
    'yearMonth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDealsTotalAmountRequest
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDealsTotalAmountRequest
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'amountLowerLimit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'amountUpperLimit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetDealsTotalAmountRequest
     */
    'qualifiedEvidence'?: GetDealsTotalAmountRequestQualifiedEvidenceEnum;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'accountItemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'taxCode'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'itemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'sectionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'tagId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'partnerId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetDealsTotalAmountRequest
     */
    'canSync'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetDealsTotalAmountRequest
     */
    'isInvalidTaxCode'?: boolean | null;
}

export const GetDealsTotalAmountRequestDealStatusListEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type GetDealsTotalAmountRequestDealStatusListEnum = typeof GetDealsTotalAmountRequestDealStatusListEnum[keyof typeof GetDealsTotalAmountRequestDealStatusListEnum];
export const GetDealsTotalAmountRequestQualifiedEvidenceEnum = {
    allNotQualified: 'ALL_NOT_QUALIFIED',
    containQualified: 'CONTAIN_QUALIFIED'
} as const;

export type GetDealsTotalAmountRequestQualifiedEvidenceEnum = typeof GetDealsTotalAmountRequestQualifiedEvidenceEnum[keyof typeof GetDealsTotalAmountRequestQualifiedEvidenceEnum];


